module.exports = __webpack_public_path__ + "static/media/loginSlider.1147e971.png";